import React from 'react';
import '../styles/FooterBar.css'
class FooterBar extends React.Component
{
    constructor() {
        super()
    }

    render()
    {
        return (
            <div className='Footer'>
                <p>Team 3 &copy; 2022. All Rights Reserved.</p>
            </div>
        );
    }
}

export default FooterBar;
